import { useState } from 'react';

import {
  useDeleteAssignmentUserMutation,
  useInsertAssigmentWithTeachingStructureMutation,
  useStudentsToAssignmentMutation,
  useUpdateAssignmentsWithTeachingStructureMutation,
} from '@school_ify/schoolify-repository/src/teacher/types';

import { useAppSelector } from 'redux/hooks';
import { liveClassStudentsState } from 'redux/liveClass/students.slices';
import { SERVICES_ENDPOINT } from 'utils/constants';

const useSaveStudy = () => {
  const [files, setFiles] = useState([]);

  const [updateAssignmentsWithTeachingStructureMutation] =
    useUpdateAssignmentsWithTeachingStructureMutation();
  const [deleteAssignmentUserMutation] = useDeleteAssignmentUserMutation();
  const [studentsToAssignmentMutation] = useStudentsToAssignmentMutation();
  const [insertAssigmentWithTeachingStructureMutation] =
    useInsertAssigmentWithTeachingStructureMutation();

  const { selectedStudents } = useAppSelector(liveClassStudentsState);

  async function saveStudents(assignmentId) {
    if (selectedStudents.length) {
      await deleteAssignmentUserMutation({
        variables: {
          _eq: assignmentId, // value for '_eq'
        },
      });
      const students = selectedStudents.map(str => {
        return {
          user_id: str,
          assignment_id: assignmentId,
        };
      });
      const studentsAddedToAssignment = await studentsToAssignmentMutation({
        variables: {
          objects: students, // value for 'objects'
        },
      });
      return studentsAddedToAssignment;
    }
  }

  const saveFiles = async (assignmentId: string) => {
    const form = new FormData();
    form.append('foreign_id', assignmentId);
    form.append('table', 'Assignments');
    files.forEach((file, index) => {
      if (file?.needsUpload) {
        form.append(`file${index}`, file);
      }
    });
    const options = {
      method: 'POST',
      body: form,
    };

    fetch(`${SERVICES_ENDPOINT}/api/file/upload`, options);
  };

  async function saveFilesAndStudents(assignmentId) {
    const saveStudentsAndFiles = await Promise.all([
      saveStudents(assignmentId),
      saveFiles(assignmentId),
    ]);
    return saveStudentsAndFiles;
  }

  const saveStudy = async model => {
    if (!model.chat_id) {
      model.chat_id = null;
    }
    let assignmentId = null;
    if (model.id) {
      const saveModel = { ...model };
      delete saveModel.id;
      await updateAssignmentsWithTeachingStructureMutation({
        variables: {
          _eq: model.id,
          assignment: saveModel,
        },
      });
      assignmentId = model.id;
    }

    if (!model.id) {
      const response = await insertAssigmentWithTeachingStructureMutation({
        variables: model,
      });
      assignmentId = response.data.insert_assignments_one.id;
    }

    await saveFilesAndStudents(assignmentId);
    return assignmentId;
  };

  return {
    saveStudy,
    setFiles,
    files,
  };
};

export default useSaveStudy;
